<template>
  <div>
    <ShowCi
      :show_dialog="show_dialog"
      :selected_ci="selected_ci"
      :closeDialog="closeShowDialog"
      :editor_open="editor_open"
      :sended="sended"
    />
    <v-data-table
      :headers="headers"
      :items="internal_communications"
      item-key="id"
      class="elevation-1"
      item-class="teste"
    >
      <template v-slot:item="{ item }">
        <tr :class="{ visualised: item.visualised }" :key="item.id" @click="showCi(item)">
          <td class="overflow-x-hidden">
            {{ item.created_by }}
          </td>
          <td
            style="max-width: 50vw; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
            class="overflow-x-hidden"
          >
            <span v-html="item.message" style="max-height: 48px" class="overflow-y-hidden d-flex"></span>
          </td>
          <td class="overflow-x-hidden">
            {{ formatDate(item.created_at) }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ShowCi from './ShowCi'
import { formatDateToShow } from '@/global/functions.js'
import { mapActions } from 'vuex'
export default {
  name: 'CiList',
  components: { ShowCi },
  props: ['internal_communications', 'sended'],
  data: function () {
    return {
      headers: [
        { text: 'De', value: 'created_by' },
        { text: 'Menssagem', value: 'message' },
        { text: 'Data', value: 'created_at' },
      ],
      selected_ci: '',
      show_dialog: false,
      new_dialog: false,
      editor_open: false,
    }
  },
  computed: {},
  methods: {
    ...mapActions('ci', ['ActionVisualizeIC']),
    formatDate(date) {
      return formatDateToShow(date)
    },
    closeShowDialog() {
      this.show_dialog = false
    },
    showCi(ci) {
      this.show_dialog = true
      this.selected_ci = ci
      if (!ci.visualised) this.ActionVisualizeIC(ci.id)
    },
    itemRowBackground(item) {
      return item.visualised ? 'row-visualised' : null
    },
  },
}
</script>

<style>
.visualised {
  background-color: #ccc;
}
</style>
